export default __webpack_public_path__ + "static/media/busyshop.05db4876.png";